import {Drawer, Row} from 'antd'
import React from 'react'
import '../../asset/less/component.css'
import PropTypes from "prop-types";

const ViewExhibitionDrawer = (props) => {
    console.log(props.element)
    let element = props.element
    const data = [
        {
            title: 'Title 1',
        },
        {
            title: 'Title 2',
        },
        {
            title: 'Title 3',
        },
        {
            title: 'Title 4',
        },
    ];
    let getContent = () => {
        return (
            <Row style={{overflowY: 'auto', width: '100%', maxWidth: 720}}>

            </Row>
        )
    }
    return (
        <Drawer
            size={'large'}
            title={element?.name?.toUpperCase()}
            placement="right"
            closable={true}
            onClose={props.onClose}
            open={!!props.open}
        >
            {element ? getContent() : null}
        </Drawer>


    )
}

// Setting default values for the props of ViewExhibitionDrawer
ViewExhibitionDrawer.defaultProps = {};

// Typechecking props for the ViewExhibitionDrawer
ViewExhibitionDrawer.propTypes = {
    element: PropTypes.object,
    open: PropTypes.bool,
    onClose: PropTypes.func
}

export default ViewExhibitionDrawer;